import './DialogAjouterDiplome.scss';

import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
//import EventBusyIcon from '@mui/icons-material/EventBusy';
import {Button, Dialog, IconButton } from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import { typeDiplomeEnum } from '../../data/Interfaces';
import useDateRangeValidator from '../../hooks/useDateRangeValidator';
import useFormValidation from '../../hooks/useFormValidation';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { DatePickerComponent, SelectComponent, TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';
import SearchCity from '../shared/SearchCity';

function DialogAjouterDiplome({open, handleClose,setDiplomes,diplomes,diplomeIndex,setDiplomeIndex}) {

    DialogAjouterDiplome.propTypes = {
        //selectedExperts: PropTypes.any,
        diplomes: PropTypes.any,
        setDiplomes:PropTypes.func,
        open: PropTypes.any,
        handleClose: PropTypes.func,
        diplomeIndex:PropTypes.any,
        setDiplomeIndex:PropTypes.func,
    };

    const { setShowErrors,setErrors } = useUtilities();
    const [localisation,setLocalisation]=useState('');
    const [typeDiplome,setTypeDiplome]=useState('');
    const [nomDiplome,setNomDiplome]=useState('');
    const [universite,setUniversite]=useState('');
    const [dateDebutDiplome,setDateDebut]=useState(null);
    const [dateFinDiplome,setDateFin]=useState(null);
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const [visibilityDateFin,setVisibilityDateFin]=useState(false);
    // const [visibleCheckEncourChamps,setVisibleCheckEnCoursChamps]=useState(false);
    // const [checkedEnCours,setCheckedEnCours]=useState();

    const [isValidRangeDateDiplome, messageRangeDateDiplome] = useDateRangeValidator(dateDebutDiplome, dateFinDiplome);
    // * required field declaration
    const [isValid] = useFormValidation([
        // { name: 'typeDiplome', value: typeDiplome },
        { name: 'nomDiplome', value: nomDiplome },
        // { name: 'universite', value: universite },
        // { name: 'localisation', value: localisation },
        // { name: 'dateDebutDiplome', value: dateDebutDiplome },
        // { name: 'dateFinDiplome', value: dateFinDiplome },
    ]);
    useEffect(() => {
        if(diplomeIndex || diplomeIndex==0){
            setDateFin(diplomes[diplomeIndex]?.dateFin);
            setDateDebut(diplomes[diplomeIndex]?.dateDebut);
            setNomDiplome(diplomes[diplomeIndex]?.formation??'');
            setUniversite(diplomes[diplomeIndex]?.universite ?? diplomes[diplomeIndex]?.institution ?? '');
            setTypeDiplome(diplomes[diplomeIndex]?.type);
            setLocalisation(diplomes[diplomeIndex]?.localisation);
            // setCheckedEnCours(diplomes[diplomeIndex]?.enCours);
            if(diplomes[diplomeIndex]?.check)
                setVisibilityDateFin(true);
        }
    }, [diplomeIndex]);

    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    // const checkDateDebDateFin=()=>{
    //     if(!dateFin){
    //         setVisibleCheckEnCoursChamps(false);
    //     }
    //     else{
    //         setVisibleCheckEnCoursChamps(true);
    //     }
    // };

    // useEffect(() => {
    //     checkDateDebDateFin();
    // }, [dateFin]);

    const AddDiplome = async () => {
        if(diplomeIndex>=0){
            const list = [...diplomes];
            list.splice(diplomeIndex, 1,{'type':typeDiplome,'formation':nomDiplome,'universite':universite,'dateDebut':dateDebutDiplome,'dateFin':dateFinDiplome,'localisation':localisation});
            setDiplomes(list);
            handleCloseRedef();
        }
        else{
            const list = [...diplomes];
            list.push({'type':typeDiplome,'formation':nomDiplome,'universite':universite,'dateDebut':dateDebutDiplome,'dateFin':dateFinDiplome,'localisation':localisation});
            setDiplomes(list);
            handleCloseRedef();
        }
    };

    const handleCloseRedef = () => {
        setDateFin(null);
        setDateDebut(null);
        setUniversite(null);
        setNomDiplome('');
        setTypeDiplome(null);
        // setCheckedEnCours(false);
        setLocalisation();
        setDiplomeIndex();
        handleClose();
    };

    const deleteDiplome = () => {
        if(diplomeIndex>=0){
            const list = [...diplomes];
            list.splice(diplomeIndex, 1);
            setDiplomes(list);
            handleCloseRedef();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleCloseRedef}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '24px',
                },
            }}
        >
            <form style={{width:device=='desktop'?'auto':'100%'}}>
                <div className='frame00FicheCollab'>
                    <div className='frame01FicheCollab'>
                        <IconButton onClick={handleCloseRedef}>
                            <CloseIcon />
                        </IconButton>

                    </div>
                </div>
                <div className='AjouterDiplomeFrame0'>
                    <div className='AjouterDiplomeFrame2'>
                        <h4 className='titlesociete'>
                            {i18n.t('Ajouter des études')}
                        </h4>
                        <div className='AjouterDiplomeFrame3'>
                            <h6 className='AjouterDiplomeFrame4'>
                                {i18n.t('Détails du diplôme')}
                            </h6>
                            <div className='AjouterDiplomeFrame5'>
                                <div className='AjouterDiplomeFrame6'>
                                    <label className='AjouterDiplomeFrame7'>{i18n.t('Nom du diplôme *')}</label>
                                    <div className='AjouterDiplomeFrame8'>
                                        <TextFieldComponent
                                            id="margin-none"
                                            multiline
                                            value={nomDiplome}
                                            name='nomDiplome'
                                            onChange={(newValue) => {
                                                setNomDiplome(newValue.target.value);
                                            }}
                                            style={{width:'600px'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='AjouterDiplomeFrame6'>
                                    <SelectComponent
                                        label={i18n.t('Diplôme *')}
                                        val={typeDiplome}
                                        name='typeDiplome'
                                        setVal={(e) => {
                                            setTypeDiplome(e.target.value);
                                        }}
                                        listVal={typeDiplomeEnum}
                                    />
                                </div>
                                <div className='AjouterDiplomeFrame9'>
                                    <SearchCity
                                        setCity={setLocalisation}
                                        city={localisation}
                                        label={i18n.t('Ville')}
                                        name='localisation'
                                        width={'100%'}
                                    />
                                </div>
                            </div>
                            <h6 className='AjouterDiplomeFrame4'>
                                {i18n.t('Université/Ecole')}
                            </h6>
                            <div className='AjouterDiplomeFrame6'>
                                <label className='AjouterDiplomeFrame7'>{i18n.t('Nom de l\'école *')}</label>
                                <div className='AjouterDiplomeFrame8'>
                                    <TextFieldComponent
                                        id="margin-none"
                                        value={universite}
                                        name='universite'
                                        onChange={(newValue) => {
                                            setUniversite(newValue.target.value);
                                        }}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px'},
                                        }}
                                        style={{width:'600px'}}
                                    />
                                </div>
                            </div>
                            <h6 className='AjouterDiplomeFrame4'>
                                {i18n.t('Durée')}
                            </h6>
                            <div className='AjouterDiplomeFrame13'>
                                <div className='AjouterDiplomeFrame14'>
                                    <label className='AjouterDiplomeFrame7'>{i18n.t('De')}</label>
                                    <div className='AjouterDiplomeFrame8'>
                                        <DatePickerComponent
                                            date={dateDebutDiplome}
                                            name='dateDebutDiplome'
                                            setDate={(newValue) => {
                                                setDateDebut(newValue);
                                            }}
                                            width={296}
                                            views={['year']}
                                        />
                                    </div>
                                </div>
                                <div className='AjouterDiplomeFrame14'>
                                    <label className='AjouterDiplomeFrame7'>{i18n.t('Au*')}</label>
                                    <div className='AjouterDiplomeFrame8'>
                                        <DatePickerComponent
                                            date={dateFinDiplome}
                                            name='dateFinDiplome'
                                            setDate={(newValue) => {
                                                setDateFin(newValue);
                                            }}
                                            disabled={visibilityDateFin}
                                            width={296}
                                            views={['year']}
                                            error={isValidRangeDateDiplome && !!messageRangeDateDiplome}
                                            helperText={isValidRangeDateDiplome ? messageRangeDateDiplome : null}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <ThemeProvider theme={FieldComponentFont}>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    checked={checkedEnCours}
                                    onChange={()=>{
                                        setCheckedEnCours(!checkedEnCours);
                                        if(!checkedEnCours==true){
                                            setDateFin(null);
                                            setVisibilityDateFin(true);
                                        }
                                        else
                                            setVisibilityDateFin(false);
                                    }}
                                    disabled={visibleCheckEncourChamps}
                                    label="Diplôme en cours"
                                />
                            </ThemeProvider> */}
                        </div>
                        <div className='AjouterDiplomeFrame11'>
                            <Button
                                variant="text"
                                startIcon={<DeleteForeverIcon />}
                                //color="error"
                                style={{...buttonStyles(),...{color:'#EC5B56'}
                                }}
                                onClick={()=>{
                                    deleteDiplome();
                                }}
                            >
                                {i18n.t('Supprimer')}
                            </Button>
                            <div className='AjouterDiplomeFrame12'>
                                <Button
                                    variant='text'
                                    style={{...buttonStyles(),...{width:'100%',order:device=='desktop'?'0':'1'}
                                    }}
                                    onClick={()=>{
                                        handleCloseRedef();
                                    }}
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                                <Button
                                    variant='contained'
                                    type='submit'
                                    style={{...buttonStylesGreen((isValidRangeDateDiplome && !!messageRangeDateDiplome)),...{width:'100%',order:device=='desktop'?'1':'0'}}}
                                    disabled={isValidRangeDateDiplome && !!messageRangeDateDiplome}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (isValid) {
                                            AddDiplome();
                                            handleCloseRedef();
                                            setShowErrors(false);
                                            setErrors({});
                                        }
                                        else setShowErrors(true);
                                    }}
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogAjouterDiplome;
